// src/shared/lib/pkce.ts

import log from "loglevel";

/**
 * Генерирует случайную строку (code verifier) для использования в PKCE.
 * @returns {string} Сгенерированная строка.
 */
function generateCodeVerifier(): string {
	const randomBytes = new Uint8Array(32);
	window.crypto.getRandomValues(randomBytes);
	const verifier = btoa(String.fromCharCode(...randomBytes))
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=/g, "");
	log.debug("Generated PKCE code verifier");
	return verifier;
}

/**
 * Генерирует code challenge из code verifier, используя SHA-256.
 * @param {string} verifier - Code verifier.
 * @returns {Promise<string>} Сгенерированный code challenge.
 */
async function generateCodeChallenge(verifier: string): Promise<string> {
	const encoder = new TextEncoder();
	const data = encoder.encode(verifier);
	const digest = await window.crypto.subtle.digest("SHA-256", data);
	const challenge = btoa(String.fromCharCode(...new Uint8Array(digest)))
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=/g, "");
	log.debug("Generated PKCE code challenge from verifier");
	return challenge;
}

/**
 * Генерирует пару code verifier и code challenge для PKCE.
 * @returns {Promise<{verifier: string, challenge: string}>} Объект с verifier и challenge.
 */
export async function generatePkcePair(): Promise<{ verifier: string; challenge: string }> {
	const verifier = generateCodeVerifier();
	const challenge = await generateCodeChallenge(verifier);
	return { verifier, challenge };
}
